import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import LogService from 'services/LogService'

export const initialState = {
    ocppLogs: {
        data: [],
        isLoading: false,
        error: false,
    },

    auditLogDynamicList: {
        data: [],
        isLoading: false,
        error: false,
    },

    ocppAuditLogDynamicList: {
        data: [],
        isLoading: false,
        error: false,
    },

    diagnosticFilesList: {
        data: [],
        isLoading: false,
        error: false,
    },

    maintenanceLogs: {
        data: [],
        isLoading: false,
        error: false,
    },

    maintenanceLogsDynamic: {
        data: [],
        isLoading: false,
        error: false,
    },

    logPageVisit: {
        data: [],
        isLoading: false,
        error: false,
    },
}

export const fetchAuditLogsDynamic = createAsyncThunk('log/getAuditLogsDynamic', async (params, { rejectWithValue }) => {
    try {
        const response = await LogService.getAuditLogsDynamic(params)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const fetchOcppAuditLogsDynamic = createAsyncThunk('log/getOcppAuditLogsDynamic', async (params, { rejectWithValue }) => {
    try {
        const response = await LogService.getOcppAuditLogsDynamic(params)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const fetchDiagnosticFiles = createAsyncThunk('log/getDiagnosticFiles', async (data, { rejectWithValue }) => {
    try {
        const response = await LogService.getDiagnosticFiles(data)
        return [...response.data]
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const fetchMaintenanceLogs = createAsyncThunk('log/getMaintenanceLogs', async (data, { rejectWithValue }) => {
    try {
        const response = await LogService.getMaintenanceLogs(data)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const fetchMaintenanceLogsDynamic = createAsyncThunk(
    'log/getMaintenanceLogsDynamic',
    async (params, { rejectWithValue }) => {
        try {
            const response = await LogService.getMaintenanceLogsDynamic(params)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchMaintenanceLogsExcel = createAsyncThunk(
    'log/getMaintenanceLogsExcel',
    async (data, { rejectWithValue }) => {
        try {
            const response = await LogService.getMaintenanceLogsExcel(data)
            return response
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchAuditLogsExcel = createAsyncThunk(
    'log/getAuditLogsExcel',
    async (data, { rejectWithValue }) => {
        try {
            const response = await LogService.getAuditLogsExcel(data)
            return response
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchOcppAuditLogsExcel = createAsyncThunk(
    'log/getOcppAuditLogsExcel',
    async (data, { rejectWithValue }) => {
        try {
            const response = await LogService.getOcppAuditLogsExcel(data)
            return response
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchOcppLogsToExcel = createAsyncThunk(
    'log/getLogsRequestResponseExcel',
    async (data, { rejectWithValue }) => {
        try {
            const response = await LogService.getOcppLogsExcel(data)
            return response
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchLogPageVisit = createAsyncThunk(
    'log/logPageVisit',
    async (data, { rejectWithValue }) => {
        try {
            const response = await LogService.logPageVisit(data)
            return response
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const logSlice = createSlice({
    name: 'logs',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            // Ocpp Logs
            .addCase(fetchOcppLogsToExcel.pending, (state, action) => {
                state.ocppLogs.isLoading = true
            })
            .addCase(fetchOcppLogsToExcel.rejected, (state, action) => {
                state.ocppLogs.isLoading = false
                state.ocppLogs.error = action.error.message
            })
            .addCase(fetchOcppLogsToExcel.fulfilled, (state, action) => {
                state.ocppLogs.isLoading = false
                state.ocppLogs.error = false
                state.ocppLogs.data = action.payload
            })

            // List Audit Logs
            .addCase(fetchAuditLogsDynamic.pending, (state, action) => {
                state.auditLogDynamicList.isLoading = true
            })
            .addCase(fetchAuditLogsDynamic.rejected, (state, action) => {
                state.auditLogDynamicList.isLoading = false
                state.auditLogDynamicList.error = action.error.message
            })
            .addCase(fetchAuditLogsDynamic.fulfilled, (state, action) => {
                state.auditLogDynamicList.isLoading = false
                state.auditLogDynamicList.error = false
                state.auditLogDynamicList.data = action.payload
            })

            // List Ocpp Audit Logs
            .addCase(fetchOcppAuditLogsDynamic.pending, (state, action) => {
                state.ocppAuditLogDynamicList.isLoading = true
            })
            .addCase(fetchOcppAuditLogsDynamic.rejected, (state, action) => {
                state.ocppAuditLogDynamicList.isLoading = false
                state.ocppAuditLogDynamicList.error = action.error.message
            })
            .addCase(fetchOcppAuditLogsDynamic.fulfilled, (state, action) => {
                state.ocppAuditLogDynamicList.isLoading = false
                state.ocppAuditLogDynamicList.error = false
                state.ocppAuditLogDynamicList.data = action.payload
            })

            // List Diagnostic Files
            .addCase(fetchDiagnosticFiles.pending, (state, action) => {
                state.diagnosticFilesList.isLoading = true
            })
            .addCase(fetchDiagnosticFiles.rejected, (state, action) => {
                state.diagnosticFilesList.isLoading = false
                state.diagnosticFilesList.error = action.error.message
            })
            .addCase(fetchDiagnosticFiles.fulfilled, (state, action) => {
                state.diagnosticFilesList.isLoading = false
                state.diagnosticFilesList.error = false
                state.diagnosticFilesList.data = action.payload
            })

            .addCase(fetchMaintenanceLogs.pending, (state, action) => {
                state.maintenanceLogs.isLoading = true
            })
            .addCase(fetchMaintenanceLogs.rejected, (state, action) => {
                state.maintenanceLogs.isLoading = false
                state.maintenanceLogs.error = action.error.message
            })
            .addCase(fetchMaintenanceLogs.fulfilled, (state, action) => {
                state.maintenanceLogs.isLoading = false
                state.maintenanceLogs.error = false
                state.maintenanceLogs.data = action.payload
            })

            .addCase(fetchMaintenanceLogsDynamic.pending, (state, action) => {
                state.maintenanceLogsDynamic.isLoading = true
            })
            .addCase(fetchMaintenanceLogsDynamic.rejected, (state, action) => {
                state.maintenanceLogsDynamic.isLoading = false
                state.maintenanceLogsDynamic.error = action.error.message
            })
            .addCase(fetchMaintenanceLogsDynamic.fulfilled, (state, action) => {
                state.maintenanceLogsDynamic.isLoading = false
                state.maintenanceLogsDynamic.error = false
                state.maintenanceLogsDynamic.data = action.payload
            })

            .addCase(fetchLogPageVisit.pending, (state, action) => {
                state.logPageVisit.isLoading = true
            })
            .addCase(fetchLogPageVisit.rejected, (state, action) => {
                state.logPageVisit.isLoading = false
                state.logPageVisit.error = action.error.message
            })
            .addCase(fetchLogPageVisit.fulfilled, (state, action) => {
                state.logPageVisit.isLoading = false
                state.logPageVisit.error = false
                state.logPageVisit.data = action.payload
            })
    },
})
export default logSlice.reducer
